import { render, staticRenderFns } from "./TheLionAndTheUnicornArticle.vue?vue&type=template&id=84b092fe&"
import script from "./TheLionAndTheUnicornArticle.vue?vue&type=script&lang=js&"
export * from "./TheLionAndTheUnicornArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports